import { roles } from "./SecurityRole.slice";

export const roleActions = { ...roles.actions };
